// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "subscription-payment-assets/box." + chunkId + "." + {"30":"de60c024","124":"b8c1be4d","188":"d88feabe","342":"e87c54ec","419":"764f7120","694":"e6f5e80e","897":"d769c97f"}[chunkId] + ".js";
};